import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setGCSMotorResponseOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getGCSMotorResponseOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const motorResponse: IOptionsResponse = yield call([optionsService, optionsService.getMotorResponse])
    const { entity } = motorResponse
    yield put(setGCSMotorResponseOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getGCSMotorResponseOptions() error: ${e}`))
  }
}

export function* getGCSMotorResponseOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getGCSMotorResponseOptions)
}
